import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/BB05_DCP.webp';

const Project_eight = () => {

  return (
   <>
   
         <div className='project_1_work' id="workBanner">
   
           <div className="container project_our_work">
   
             <div className="heading">
               <h1>BB05 Empower District Cooling Plant — Phase 2</h1>
             </div>
   
             <hr></hr>
             <div className='project_section'>
               <div className="project_section_content">
                 <h1 className="project_scope">Scope of Work</h1>
                 <p>Phase 2 expansion of the Empower district cooling plant serving the high-density Business Bay cluster — one of Dubai's
                    primary commercial and residential hubs. Empower is the world's largest district cooling services provider.</p>
                 <p>MAIN CONTRACTOR : -</p>
                 <p>MEP CONTRACTOR : AGE</p>
                 <p>GEMCO SCOPE OF WORKS : CHW main package works — Phase 2 expansion</p>
                 {/* <h2 className="project_years">2014 – 2022</h2> */}
               </div>
               <div className='project_1_card'>
                 <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
               </div>
             </div>
           </div>
         </div>
   
       </>

  )
}

export default Project_eight